import { AppData, Application } from "@/models/application";
import * as jsonPatch from "fast-json-patch";
import { ref, Ref, computed, watch } from "vue";
import { $api } from "@/services/api";

export default function useApplicationPatch(
  store: any,
  options: {
    updatingApp: Ref<boolean>;
    error: Ref<boolean>;
    editingFromConfirmYourLoanDetails: Ref<boolean>;
  },
) {
  const appObserver = ref({} as jsonPatch.Observer<Application>);

  const appData = computed<AppData>(() => store.state.appData);

  const application = computed(() => store.state.appData.application);

  function filterApplicationPatches(patches: jsonPatch.Operation[]) {
    if (patches.length === 0) {
      return patches;
    }

    const validApplicationPaths = [
      "programTypeId",
      "loanId",
      "statusReasonId",
      "metadata",
      "schoolConfiguration",
      "applicationRefiSchool",
      "student",
    ];

    const filteredPatches = patches.filter(patch =>
      validApplicationPaths.some(validPath => patch?.path?.startsWith(`/${validPath}`)),
    );
    return filteredPatches;
  }

  function refreshObservers() {
    if (store.state.appData.application) {
      const application = store.state.appData.application;

      appObserver.value = jsonPatch.observe<Application>(application);
      console.log("refreshObservers()", appObserver.value);
    }
  }

  async function updateAppData() {
    const application = store.state.appData.application;
    appObserver.value = jsonPatch.observe<Application>(application);

    const applicationPatch = jsonPatch.generate(appObserver.value);

    // filter out specific patches
    const filteredApplicationPatches = filterApplicationPatches(applicationPatch);

    // console.log("APPLICATION PATCH", filteredApplicationPatches);
    console.log("APPLICATION PATCH", {
      original: applicationPatch,
      filtered: filteredApplicationPatches,
    });

    const updatedAppData = await $api.applications.updateApplication(
      appData.value?.currentApplicant?.userId ?? "",
      application.id,
      filteredApplicationPatches,
      options.editingFromConfirmYourLoanDetails.value,
    );
    console.log("UPDATED APP DATA", updatedAppData);
    if (!updatedAppData.error || updatedAppData.id) {
      await store.dispatch("setAppDataApplicationAndApplicants", updatedAppData);
    } else {
      options.error.value = true;
      options.updatingApp.value = false;
      alert("Something has gone wrong");
    }
  }
  watch(
    () => application.value,
    () => {
      refreshObservers();
    },
  );
  return { appObserver, filterApplicationPatches, refreshObservers, updateAppData };
}
